import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// Components

import Image from '../image/Image';
import GenericHeader from '../pageHeader/GenericHeader';

// Constants

import { configs } from '@constants/configs/configs';
import states from '@constants/configs/states';

const SsapDuplicationFallback = props => {

    const { stateCode } = props;

    let errorImage = '';

    if( stateCode === states.NEW_JERSEY ) {
        errorImage = configs.ENV.DEVELOPMENT ? `../../../assets/images/${stateCode.toLowerCase()}-newtab-error-illustration.png`
            : configs.endpoints.IMAGES.processReplacements({
                relativePath: '/resources/img',
                fileName: `${stateCode.toLowerCase()}-newtab-error-illustration.png`
            });
    } else {
        errorImage = configs.ENV.DEVELOPMENT ? `../../../assets/images/${stateCode.toLowerCase()}-error-illustration.png`
            : configs.endpoints.IMAGES.processReplacements({
                relativePath: '/resources/img',
                fileName: `${stateCode.toLowerCase()}-error-illustration.png`
            });
    }

    return (
        <Fragment>
            <main className="usa-layout-docs usa-section gi-main-section" id="gi-fallback__container">
                <div className="grid-container gi-grid-container">
                    <div className="grid-row grid-gap gi-wrapper gi-fallback">
                        <div className="desktop:grid-col-5 tablet:grid-col-5 mobile:grid-col-12 gi-fallback__item gi-fallback__content">
                            <GenericHeader
                                tag="h1"
                                id="error-header"
                                text="common.ssap_duplication_fallback.header"
                                headerClassName={['mobile:grid-col-12 tablet:grid-col-fill gi-fallback__content__header']}
                            />
                            <GenericHeader
                                tag="p"
                                id="error-content"
                                text="common.ssap_duplication_fallback.message"
                                headerClassName={['mobile:grid-col-12 tablet:grid-col-fill gi-fallback__content__msg']}
                            />
                        </div>
                        <div className="desktop:grid-col-5 tablet:grid-col-5 mobile:grid-col-12 gi-fallback__item gi-fallback__item gi-fallback__img">
                            <Image
                                { ...
                                    {
                                        source: errorImage,
                                        desc: 'session.error.content.img.desc',
                                        name: 'system__error_img',
                                        classes: []
                                    }
                                }
                            />
                        </div>
                    </div>
                </div>
            </main>
        </Fragment>
    );
};

SsapDuplicationFallback.propTypes = {
    stateCode: PropTypes.string.isRequired
};

export default SsapDuplicationFallback;